import React, { } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide} from "swiper/react";
import './slideshow.css'

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import mm1pic from '../components/posts/23-24/pictures/mm1pic.jpg';
import ghc3 from '../components/posts/23-24/pictures/ghc3.jpg';
import ghc1 from '../components/posts/23-24/pictures/ghc1.jpg';
import uberpic from '../components/posts/23-24/pictures/uberpic.jpg';
import googlepic from '../components/posts/23-24/pictures/googlepic.jpg';


// import required modules
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper";

const Slideshow = () => {

  const images = [mm1pic, ghc3, ghc1, uberpic, googlepic];


  return (
    <>
      <Swiper
        spaceBetween={0}
        centeredSlides={true}
        // effect="fade"
        // fadeEffect={{
        //   crossFade: true // enables slides to cross fade
        // }}
        speed={1200}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={false}
        loop={true}
        modules={[Autoplay, Pagination, Navigation, EffectFade]}
        className="mySwiper"
      >
        {images.map((img, index) => (
          <SwiperSlide className="slide" key={index}><img src={img} alt='wic'/></SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}

export default Slideshow